import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    titleColors: [
      'h-article-color-green',
      'h-article-color-blue',
      'h-article-color-red',
    ]
  },
  mutations: {
  },
  actions: {
    scrollToTop() {
      window.scroll(0, 0)
    }
  },
  modules: {
  }
})
